import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/AddRole.css";
import { API_URL } from "../../config";
import { useNavigate, useParams } from "react-router-dom";
import RoleMenu from "./components/RoleMenu";
import { showToast } from "../../components/toast";

const AddRole = () => {
  const [roleName, setRoleName] = useState("");
  const [department, setDepartment] = useState("");
  const [roleDetails, setRoleDetails] = useState({});
  const [userRoles, setUserRoles] = useState([]);
  const [error, setError] = useState("");
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const { id } = useParams();

  const managePage = id ? "Edit Role" : "Add Role";
  const departmentList = [
    { id: 1, name: "Sales" },
    { id: 2, name: "Research" },
    { id: 3, name: "Accounts" },
    { id: 4, name: "Marketing" },
  ];


  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const response = await axios.get(`${API_URL}hrms/role/add`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          // Directly use userroles from response
          setUserRoles(response.data.userroles || []);
        }
      } catch (error) {
        setError("Failed to fetch user roles.");
        console.error("API fetch error:", error);
      }
    };

    const fetchRoleDetails = async () => {
      try {
        const response = await axios.get(`${API_URL}hrms/role/add?id=${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          if (response.data.role) {
            setRoleName(response.data.role.user_role);
            // Convert department to string for select element
            setDepartment(response.data.role.department_id?.toString() || response.data.role.department?.toString() || '');
            let roleDetailsData = {};
            if (typeof response.data.role.role_details === 'string') {
              try {
                roleDetailsData = JSON.parse(response.data.role.role_details);
              } catch (e) {
                roleDetailsData = {};
              }
            } else if (response.data.role.role_details && typeof response.data.role.role_details === 'object') {
              roleDetailsData = response.data.role.role_details;
            }
            setRoleDetails(roleDetailsData || {});
          }

          // Set user roles directly from response
          if (response.data.userroles) {
            setUserRoles(response.data.userroles);
          }
        }
      } catch (error) {
        setError("Failed to fetch role details.");
        console.error("API fetch error:", error);
      }
    };

    fetchUserRoles();
    if (id) fetchRoleDetails();
  }, [id, token]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!roleName) {
      setError("Please Enter Role Name");
      return;
    }

    try {
      let response;
      
      if (id) {
        // Edit role
        const editRoleData = {
          id: parseInt(id),
          role_id: parseInt(id),
          department: department ? parseInt(department) : 0,
          role: roleDetails // roleDetails already contains the permissions structure
        };

        response = await axios.post(
          `${API_URL}hrms/role/save-user-role`,
          editRoleData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } else {
        // Add new role
        const newRoleData = {
          user_role: roleName,
          role_details: roleDetails, // Send roleDetails directly as an object
          department: department ? parseInt(department) : 0,
          isdelete: 0
        };

        response = await axios.post(
          `${API_URL}hrms/role/save`,
          newRoleData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }

      if (response.status === 201 && response.data.success) {
        // navigate("/Hrms/Role");
        showToast.success(response.data.message || "Role saved successfully.");
      } else {
        setError(response.data.message || "Failed to save role.");
        showToast.error(response.data.message || "Failed to save role.");
      }
    } catch (error) {
      console.error(`${managePage} error:`, error);
      setError(error.response?.data?.message || "Failed to save role.");
    }
  };

  return (
    <div className="mt-5">
      <div className="card shadow-sm rounded p-4">
        <form onSubmit={handleSubmit}>
          <h3 className="text-center mb-4">{managePage}</h3>

          <div className="row">
            <div className="form-group mb-4 col-6">
              <label className="font-weight-bold">Role Name</label>
              <input
                type="text"
                placeholder="Enter Role Name"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>

            <div className="form-group mb-4 col-6">
              <label className="font-weight-bold">Department</label>
              <select
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
                className="form-control"
              >
                <option value="">Select Department</option>
                {departmentList.map((dept) => (
                  <option key={dept.id} value={dept.id}>
                    {dept.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="permissions-section mb-4">
            <ul className="role_ul maintop">
              <li>Functionality 
                  <div className="pull-right">
                    <span>Share</span>
                    <span>Export</span>
                    <span>Import</span>
                    <span>Delete</span>
                    <span>Edit</span>
                    <span>Add</span>
                    <span>View</span>
                  </div>
              </li>
            </ul>

            {userRoles.map((role) => (
              <ul key={role.role} className="role_ul">
                <RoleMenu
                  menu={role}
                  valRoleDetails={roleDetails}
                  updateRoleDetails={setRoleDetails}
                  onPermissionChange={(menuSlug, perm, isChecked) => {
                    setRoleDetails((prev) => {
                      const updated = { ...prev };
                      if (!updated[menuSlug]) updated[menuSlug] = {};
                      updated[menuSlug][perm] = isChecked ? '1' : '0';
                      return updated;
                    });
                  }}
                />
              </ul>
            ))}
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <div className="text-center">
            <button
              type="submit"
              className="btn btn-primary btn-sm btn-block"
              onClick={handleSubmit}
            >Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddRole;
